<div class="range-container padding">
  <lms-range [config]="rangeConfig"></lms-range>
</div>

<lms-toolbar [options]="toolbarConfig"></lms-toolbar>

<div class="gl-table__container">
  <gl-table
    [id]="listId"
    data-testid="marsGroupActivityList"
    [dataSource]="dataSource"
    [placeholder]="'actions.noResultTable' | translate"
    paginator
    scroll
    (onDatasourceUpdate)="onDatasourceUpdate()"
  >
  </gl-table>
</div>